import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPortraitDefault({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={20} cy={20} r={20} fill="#F4F5FB" />
      <path
        opacity={0.6}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 20.04A4.52 4.52 0 1020 11a4.52 4.52 0 000 9.04zm0 1.05c2.04 0 3.17.27 3.96.55 1.94.68 4.04 2.1 4.04 5.18 0 .78-.56 1.36-1.54 1.68-1.19.4-4.22.5-6.46.5s-5.27-.1-6.46-.5c-.98-.32-1.54-.9-1.54-1.68 0-3.09 2.1-4.5 4.04-5.18.79-.28 1.92-.55 3.96-.55z"
        fill="#8F9DD6"
      />
    </svg>
  );
}

SvgPortraitDefault.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPortraitDefault.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPortraitDefault svgRef={ref} {...props} />);
export default ForwardRef;
